export const Logger = (store) => (next) => (action) => {
    //console.log('Logger', action);
    next(action);
}